// 個別支援計画のエンティティ
export class SupportPlan {
  // 個別支援計画ID DB型(*autokey)
  public support_plan_id?: number;
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 利用サービス DB型(*varchar256)
  public service_type?: string;
  // 作成日 DB型(DATETIME)
  public create_dt?: Date;
  // モニタリング作成日 DB型(@DATETIME)
  public monitoring_create_dt?: Date;
  // 期間開始 DB型(DATETIME)
  public start_dt?: Date;
  // 期間終了 DB型(DATETIME)
  public end_dt?: Date;
  // 総合的な支援方針 DB型(MEDIUMTEXT)
  public total_support_plan?: string;
  // 備考 DB型(MEDIUMTEXT)
  public note_plan?: string;
  // 備考(モニタリング) DB型(MEDIUMTEXT)
  public note_monitoring?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): SupportPlan {
    const entity = new SupportPlan();
    entity.support_plan_id = record['support_plan_id'];
    entity.user_id = record['user_id'];
    entity.service_type = record['service_type'];
    entity.create_dt = record['create_dt'];
    entity.monitoring_create_dt = record['monitoring_create_dt'];
    entity.start_dt = record['start_dt'];
    entity.end_dt = record['end_dt'];
    entity.total_support_plan = record['total_support_plan'];
    entity.note_plan = record['note_plan'];
    entity.note_monitoring = record['note_monitoring'];
    return entity;
  }
  static getTypeFitEntity(value: any): SupportPlan {
    const entity = new SupportPlan();
    entity.support_plan_id = value.support_plan_id;
    entity.user_id = value.user_id;
    entity.service_type = value.service_type;
    entity.create_dt = value.create_dt;
    entity.monitoring_create_dt = value.monitoring_create_dt;
    entity.start_dt = value.start_dt;
    entity.end_dt = value.end_dt;
    entity.total_support_plan = value.total_support_plan;
    entity.note_plan = value.note_plan;
    entity.note_monitoring = value.note_monitoring;
    return entity;
  }
}
